import { useAuthGuard } from "@features/auth";

/** Must render inside <RouterProvider> — syncs session and applies route redirects. */
export function AuthGuardian() {
  useAuthGuard();
  return null;
}
